import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { AxiosError } from 'axios';
import { authApiClient } from '../../../utils/axios';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
export const deactivateUser = async (userId) => {
  const { data } = await authApiClient.delete(`/users/${userId}`);
  return data;
};

export const useDeactivateUserHandler = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const { settings } = useTranslatedMessages();
  const teamSnacks = settings.team?.snackbar ?? {};

  const mutation = useMutation({
    mutationFn: deactivateUser,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['auth-users'] });
      dispatch(
        showSnackbar({
          message: data?.message || teamSnacks.deactivate_success || 'User deactivated successfully',
          severity: 'success',
        }),
      );
    },
    onError: (error) => {
      const message =
        error instanceof AxiosError
          ? error.response?.data?.errors?.message || error.message
          : teamSnacks.deactivate_error || 'Failed to deactivate user';
      dispatch(showSnackbar({ message, severity: 'error' }));
    },
  });

  return {
    mutate: mutation.mutate,
    isPending: mutation.isPending,
  };
};
